import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../CommonComponents/Button';
import getImagePath from '../CommonUtils/getImagePath';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 75%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

interface Props {
  clientId: string;
}

export const Schwab = ({ clientId }: Props) => {
  useDocumentTitle('Schwab');

  return (
    <Wrapper>
      <img
        style={{ maxWidth: 180, width: '100%', marginBottom: 24 }}
        src={getImagePath('schwab.svg')}
        alt="Schwab Alliance logo"
      />
      <PrimaryButton
        onClick={() => {
          window.open(`/Consumer/Schwab/LaunchSchwab?clientId=${clientId}`, '_blank');
        }}
      >
        Launch Schwab Alliance
      </PrimaryButton>
    </Wrapper>
  );
};
